
import FileDowload from '../../../assets/files/Daytopia Investment Club.pdf'

const DownloadFIleClub = () => {
    const styles = {
        FilesDownload:{
        },
        FIlesCont : {
          padding: '10px 20px',
          border: 'none',
          outline: 'none',
          marginBottom: '52px',
          background: '#2e8ece',
          borderRadius: '50px'
        },
        File:{
            color: '#fff',
           
        }
    }

  return (
    <div className="container">
    <div style={styles.FilesDownload}>
      <button style={styles.FIlesCont}><a style={styles.File} href={FileDowload} download>Download our 2023 Q4 Financial Report Here:</a></button>
      </div>
    </div>
  )
}

export default DownloadFIleClub